import axios from "axios";

const rawApiUrl = process.env.REACT_APP_API_URL || "/api";
// Upgrade http:// → https:// to prevent Mixed Content errors when served over HTTPS
const API_URL =
  typeof window !== "undefined" &&
  window.location.protocol === "https:" &&
  rawApiUrl.startsWith("http://")
    ? rawApiUrl.replace("http://", "https://")
    : rawApiUrl;

const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

export default api;
